import MuiFormGroup, { FormGroupProps as MuiFormGroupProps } from '@mui/material/FormGroup';
import { styled } from '@mui/material/styles';
import { shouldForwardProp as sysShouldForwardProp } from '@mui/system';

export * from '@mui/material/FormGroup';

export interface FormGroupProps extends MuiFormGroupProps {
  /**
   * Disable the 'gap' CSS property, which is set to 32px by default if 'row'.
   */
  noGap?: boolean;
}

// please keep any potential changes in added props etc. in sync with RadioGroup
const StyledFormGroup = styled(MuiFormGroup, {
  shouldForwardProp: (prop) => sysShouldForwardProp(prop) && prop !== 'noGap',
})<FormGroupProps>(({ noGap }) => ({
  ...(noGap && {
    gap: 0,
  }),
}));

export default StyledFormGroup;
